import axios from "@/axios";
import * as sentry from "@sentry/react";
import { isAxiosError } from "axios";

async function removePushNotificationSubscription() {
  try {
    await axios.delete("/bff/api/push-notifications/subscriptions/");
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      // Subscription not found, no action needed
      return;
    }
    sentry.captureException(error);
  }
}

async function removeServiceWorkerRegistration() {
  if (!("serviceWorker" in navigator)) return;

  const registration = await navigator.serviceWorker.getRegistration(
    "/service-worker.js"
  );

  if (!registration) return;

  const subscription = await registration.pushManager.getSubscription();

  if (subscription) {
    await subscription.unsubscribe();
  }

  await registration.unregister();
}

export async function unsubscribeUserFromPush() {
  await removePushNotificationSubscription();

  try {
    await removeServiceWorkerRegistration();
  } catch (error) {
    sentry.captureException(error);
  }
}
